import { default as _91page_939EwnUdT5E6Meta } from "/Users/xiongzhifan/yinuo/proj_codes/PixelHaha-SSR/pages/images-photos/[page].vue?macro=true";
import { default as _91title_93_45_91taskId_93oaWolgCceFMeta } from "/Users/xiongzhifan/yinuo/proj_codes/PixelHaha-SSR/pages/images-photos/[title]-[taskId].vue?macro=true";
import { default as _91page_931xUPaksKrWMeta } from "/Users/xiongzhifan/yinuo/proj_codes/PixelHaha-SSR/pages/images-photos/hot/[category]/[page].vue?macro=true";
import { default as indexnLfO8qGlACMeta } from "/Users/xiongzhifan/yinuo/proj_codes/PixelHaha-SSR/pages/images-photos/hot/[category]/index.vue?macro=true";
import { default as _91page_93sDyELOHgsHMeta } from "/Users/xiongzhifan/yinuo/proj_codes/PixelHaha-SSR/pages/images-photos/hot/[page].vue?macro=true";
import { default as indexpyKix6EsBTMeta } from "/Users/xiongzhifan/yinuo/proj_codes/PixelHaha-SSR/pages/images-photos/hot/index.vue?macro=true";
import { default as indexXMhACsrWdSMeta } from "/Users/xiongzhifan/yinuo/proj_codes/PixelHaha-SSR/pages/images-photos/index.vue?macro=true";
import { default as _91page_93wVwUrNAwmYMeta } from "/Users/xiongzhifan/yinuo/proj_codes/PixelHaha-SSR/pages/images-photos/pictures/[keyword]/[page].vue?macro=true";
import { default as _91keyword_93amRLrxX8YfMeta } from "/Users/xiongzhifan/yinuo/proj_codes/PixelHaha-SSR/pages/images-photos/pictures/[keyword].vue?macro=true";
import { default as _91id_93oVUqjB0IzzMeta } from "/Users/xiongzhifan/yinuo/proj_codes/PixelHaha-SSR/pages/images-photos/publisher/[id].vue?macro=true";
import { default as indexV4veI1YKF7Meta } from "/Users/xiongzhifan/yinuo/proj_codes/PixelHaha-SSR/pages/index.vue?macro=true";
import { default as indexLgpKWkoNXDMeta } from "/Users/xiongzhifan/yinuo/proj_codes/PixelHaha-SSR/pages/siteMap/index.vue?macro=true";
export default [
  {
    name: "images-photos-page___en",
    path: "/images-photos/:page()",
    component: () => import("/Users/xiongzhifan/yinuo/proj_codes/PixelHaha-SSR/pages/images-photos/[page].vue").then(m => m.default || m)
  },
  {
    name: "images-photos-page___es",
    path: "/im%C3%A1genes-fotos/:page()",
    component: () => import("/Users/xiongzhifan/yinuo/proj_codes/PixelHaha-SSR/pages/images-photos/[page].vue").then(m => m.default || m)
  },
  {
    name: "images-photos-page___fr",
    path: "/images-photos/:page()",
    component: () => import("/Users/xiongzhifan/yinuo/proj_codes/PixelHaha-SSR/pages/images-photos/[page].vue").then(m => m.default || m)
  },
  {
    name: "images-photos-page___ja",
    path: "/%E7%94%BB%E5%83%8F-%E5%86%99%E7%9C%9F/:page()",
    component: () => import("/Users/xiongzhifan/yinuo/proj_codes/PixelHaha-SSR/pages/images-photos/[page].vue").then(m => m.default || m)
  },
  {
    name: "images-photos-page___pt",
    path: "/imagens-fotos/:page()",
    component: () => import("/Users/xiongzhifan/yinuo/proj_codes/PixelHaha-SSR/pages/images-photos/[page].vue").then(m => m.default || m)
  },
  {
    name: "images-photos-title-taskId___en",
    path: "/images-photos/:title()-:taskId()",
    component: () => import("/Users/xiongzhifan/yinuo/proj_codes/PixelHaha-SSR/pages/images-photos/[title]-[taskId].vue").then(m => m.default || m)
  },
  {
    name: "images-photos-title-taskId___es",
    path: "/im%C3%A1genes-fotos/:title()-:taskId()",
    component: () => import("/Users/xiongzhifan/yinuo/proj_codes/PixelHaha-SSR/pages/images-photos/[title]-[taskId].vue").then(m => m.default || m)
  },
  {
    name: "images-photos-title-taskId___fr",
    path: "/images-photos/:title()-:taskId()",
    component: () => import("/Users/xiongzhifan/yinuo/proj_codes/PixelHaha-SSR/pages/images-photos/[title]-[taskId].vue").then(m => m.default || m)
  },
  {
    name: "images-photos-title-taskId___ja",
    path: "/%E7%94%BB%E5%83%8F-%E5%86%99%E7%9C%9F/:title()-:taskId()",
    component: () => import("/Users/xiongzhifan/yinuo/proj_codes/PixelHaha-SSR/pages/images-photos/[title]-[taskId].vue").then(m => m.default || m)
  },
  {
    name: "images-photos-title-taskId___pt",
    path: "/imagens-fotos/:title()-:taskId()",
    component: () => import("/Users/xiongzhifan/yinuo/proj_codes/PixelHaha-SSR/pages/images-photos/[title]-[taskId].vue").then(m => m.default || m)
  },
  {
    name: "images-photos-hot-category-page___en",
    path: "/images-photos/hot/:category()/:page()",
    component: () => import("/Users/xiongzhifan/yinuo/proj_codes/PixelHaha-SSR/pages/images-photos/hot/[category]/[page].vue").then(m => m.default || m)
  },
  {
    name: "images-photos-hot-category-page___es",
    path: "/im%C3%A1genes-fotos/caliente/:category()/:page()",
    component: () => import("/Users/xiongzhifan/yinuo/proj_codes/PixelHaha-SSR/pages/images-photos/hot/[category]/[page].vue").then(m => m.default || m)
  },
  {
    name: "images-photos-hot-category-page___fr",
    path: "/images-photos/chaud/:category()/:page()",
    component: () => import("/Users/xiongzhifan/yinuo/proj_codes/PixelHaha-SSR/pages/images-photos/hot/[category]/[page].vue").then(m => m.default || m)
  },
  {
    name: "images-photos-hot-category-page___ja",
    path: "/%E7%94%BB%E5%83%8F-%E5%86%99%E7%9C%9F/%E7%86%B1%E3%81%84/:category()/:page()",
    component: () => import("/Users/xiongzhifan/yinuo/proj_codes/PixelHaha-SSR/pages/images-photos/hot/[category]/[page].vue").then(m => m.default || m)
  },
  {
    name: "images-photos-hot-category-page___pt",
    path: "/imagens-fotos/quente/:category()/:page()",
    component: () => import("/Users/xiongzhifan/yinuo/proj_codes/PixelHaha-SSR/pages/images-photos/hot/[category]/[page].vue").then(m => m.default || m)
  },
  {
    name: "images-photos-hot-category___en",
    path: "/images-photos/hot/:category()",
    component: () => import("/Users/xiongzhifan/yinuo/proj_codes/PixelHaha-SSR/pages/images-photos/hot/[category]/index.vue").then(m => m.default || m)
  },
  {
    name: "images-photos-hot-category___es",
    path: "/im%C3%A1genes-fotos/caliente/:category()",
    component: () => import("/Users/xiongzhifan/yinuo/proj_codes/PixelHaha-SSR/pages/images-photos/hot/[category]/index.vue").then(m => m.default || m)
  },
  {
    name: "images-photos-hot-category___fr",
    path: "/images-photos/chaud/:category()",
    component: () => import("/Users/xiongzhifan/yinuo/proj_codes/PixelHaha-SSR/pages/images-photos/hot/[category]/index.vue").then(m => m.default || m)
  },
  {
    name: "images-photos-hot-category___ja",
    path: "/%E7%94%BB%E5%83%8F-%E5%86%99%E7%9C%9F/%E7%86%B1%E3%81%84/:category()",
    component: () => import("/Users/xiongzhifan/yinuo/proj_codes/PixelHaha-SSR/pages/images-photos/hot/[category]/index.vue").then(m => m.default || m)
  },
  {
    name: "images-photos-hot-category___pt",
    path: "/imagens-fotos/quente/:category()",
    component: () => import("/Users/xiongzhifan/yinuo/proj_codes/PixelHaha-SSR/pages/images-photos/hot/[category]/index.vue").then(m => m.default || m)
  },
  {
    name: "images-photos-hot-page___en",
    path: "/images-photos/hot/:page()",
    component: () => import("/Users/xiongzhifan/yinuo/proj_codes/PixelHaha-SSR/pages/images-photos/hot/[page].vue").then(m => m.default || m)
  },
  {
    name: "images-photos-hot-page___es",
    path: "/im%C3%A1genes-fotos/caliente/:page()",
    component: () => import("/Users/xiongzhifan/yinuo/proj_codes/PixelHaha-SSR/pages/images-photos/hot/[page].vue").then(m => m.default || m)
  },
  {
    name: "images-photos-hot-page___fr",
    path: "/images-photos/chaud/:page()",
    component: () => import("/Users/xiongzhifan/yinuo/proj_codes/PixelHaha-SSR/pages/images-photos/hot/[page].vue").then(m => m.default || m)
  },
  {
    name: "images-photos-hot-page___ja",
    path: "/%E7%94%BB%E5%83%8F-%E5%86%99%E7%9C%9F/%E7%86%B1%E3%81%84/:page()",
    component: () => import("/Users/xiongzhifan/yinuo/proj_codes/PixelHaha-SSR/pages/images-photos/hot/[page].vue").then(m => m.default || m)
  },
  {
    name: "images-photos-hot-page___pt",
    path: "/imagens-fotos/quente/:page()",
    component: () => import("/Users/xiongzhifan/yinuo/proj_codes/PixelHaha-SSR/pages/images-photos/hot/[page].vue").then(m => m.default || m)
  },
  {
    name: "images-photos-hot___en",
    path: "/images-photos/hot",
    component: () => import("/Users/xiongzhifan/yinuo/proj_codes/PixelHaha-SSR/pages/images-photos/hot/index.vue").then(m => m.default || m)
  },
  {
    name: "images-photos-hot___es",
    path: "/im%C3%A1genes-fotos/caliente",
    component: () => import("/Users/xiongzhifan/yinuo/proj_codes/PixelHaha-SSR/pages/images-photos/hot/index.vue").then(m => m.default || m)
  },
  {
    name: "images-photos-hot___fr",
    path: "/images-photos/chaud",
    component: () => import("/Users/xiongzhifan/yinuo/proj_codes/PixelHaha-SSR/pages/images-photos/hot/index.vue").then(m => m.default || m)
  },
  {
    name: "images-photos-hot___ja",
    path: "/%E7%94%BB%E5%83%8F-%E5%86%99%E7%9C%9F/%E7%86%B1%E3%81%84",
    component: () => import("/Users/xiongzhifan/yinuo/proj_codes/PixelHaha-SSR/pages/images-photos/hot/index.vue").then(m => m.default || m)
  },
  {
    name: "images-photos-hot___pt",
    path: "/imagens-fotos/quente",
    component: () => import("/Users/xiongzhifan/yinuo/proj_codes/PixelHaha-SSR/pages/images-photos/hot/index.vue").then(m => m.default || m)
  },
  {
    name: "images-photos___en",
    path: "/images-photos",
    component: () => import("/Users/xiongzhifan/yinuo/proj_codes/PixelHaha-SSR/pages/images-photos/index.vue").then(m => m.default || m)
  },
  {
    name: "images-photos___es",
    path: "/im%C3%A1genes-fotos",
    component: () => import("/Users/xiongzhifan/yinuo/proj_codes/PixelHaha-SSR/pages/images-photos/index.vue").then(m => m.default || m)
  },
  {
    name: "images-photos___fr",
    path: "/images-photos",
    component: () => import("/Users/xiongzhifan/yinuo/proj_codes/PixelHaha-SSR/pages/images-photos/index.vue").then(m => m.default || m)
  },
  {
    name: "images-photos___ja",
    path: "/%E7%94%BB%E5%83%8F-%E5%86%99%E7%9C%9F",
    component: () => import("/Users/xiongzhifan/yinuo/proj_codes/PixelHaha-SSR/pages/images-photos/index.vue").then(m => m.default || m)
  },
  {
    name: "images-photos___pt",
    path: "/imagens-fotos",
    component: () => import("/Users/xiongzhifan/yinuo/proj_codes/PixelHaha-SSR/pages/images-photos/index.vue").then(m => m.default || m)
  },
  {
    name: "images-photos-pictures-keyword___en",
    path: "/images-photos/pictures/:keyword()",
    component: () => import("/Users/xiongzhifan/yinuo/proj_codes/PixelHaha-SSR/pages/images-photos/pictures/[keyword].vue").then(m => m.default || m),
    children: [
  {
    name: "images-photos-pictures-keyword-page___en",
    path: ":page()",
    component: () => import("/Users/xiongzhifan/yinuo/proj_codes/PixelHaha-SSR/pages/images-photos/pictures/[keyword]/[page].vue").then(m => m.default || m)
  }
]
  },
  {
    name: "images-photos-pictures-keyword___es",
    path: "/im%C3%A1genes-fotos/fotos/:keyword()",
    component: () => import("/Users/xiongzhifan/yinuo/proj_codes/PixelHaha-SSR/pages/images-photos/pictures/[keyword].vue").then(m => m.default || m),
    children: [
  {
    name: "images-photos-pictures-keyword-page___es",
    path: ":page()",
    component: () => import("/Users/xiongzhifan/yinuo/proj_codes/PixelHaha-SSR/pages/images-photos/pictures/[keyword]/[page].vue").then(m => m.default || m)
  }
]
  },
  {
    name: "images-photos-pictures-keyword___fr",
    path: "/images-photos/photos/:keyword()",
    component: () => import("/Users/xiongzhifan/yinuo/proj_codes/PixelHaha-SSR/pages/images-photos/pictures/[keyword].vue").then(m => m.default || m),
    children: [
  {
    name: "images-photos-pictures-keyword-page___fr",
    path: ":page()",
    component: () => import("/Users/xiongzhifan/yinuo/proj_codes/PixelHaha-SSR/pages/images-photos/pictures/[keyword]/[page].vue").then(m => m.default || m)
  }
]
  },
  {
    name: "images-photos-pictures-keyword___ja",
    path: "/%E7%94%BB%E5%83%8F-%E5%86%99%E7%9C%9F/%E5%86%99%E7%9C%9F/:keyword()",
    component: () => import("/Users/xiongzhifan/yinuo/proj_codes/PixelHaha-SSR/pages/images-photos/pictures/[keyword].vue").then(m => m.default || m),
    children: [
  {
    name: "images-photos-pictures-keyword-page___ja",
    path: ":page()",
    component: () => import("/Users/xiongzhifan/yinuo/proj_codes/PixelHaha-SSR/pages/images-photos/pictures/[keyword]/[page].vue").then(m => m.default || m)
  }
]
  },
  {
    name: "images-photos-pictures-keyword___pt",
    path: "/imagens-fotos/fotos/:keyword()",
    component: () => import("/Users/xiongzhifan/yinuo/proj_codes/PixelHaha-SSR/pages/images-photos/pictures/[keyword].vue").then(m => m.default || m),
    children: [
  {
    name: "images-photos-pictures-keyword-page___pt",
    path: ":page()",
    component: () => import("/Users/xiongzhifan/yinuo/proj_codes/PixelHaha-SSR/pages/images-photos/pictures/[keyword]/[page].vue").then(m => m.default || m)
  }
]
  },
  {
    name: "images-photos-publisher-id___en",
    path: "/images-photos/publisher/:id()",
    component: () => import("/Users/xiongzhifan/yinuo/proj_codes/PixelHaha-SSR/pages/images-photos/publisher/[id].vue").then(m => m.default || m)
  },
  {
    name: "images-photos-publisher-id___es",
    path: "/im%C3%A1genes-fotos/editor/:id()",
    component: () => import("/Users/xiongzhifan/yinuo/proj_codes/PixelHaha-SSR/pages/images-photos/publisher/[id].vue").then(m => m.default || m)
  },
  {
    name: "images-photos-publisher-id___fr",
    path: "/images-photos/%C3%A9diteur/:id()",
    component: () => import("/Users/xiongzhifan/yinuo/proj_codes/PixelHaha-SSR/pages/images-photos/publisher/[id].vue").then(m => m.default || m)
  },
  {
    name: "images-photos-publisher-id___ja",
    path: "/%E7%94%BB%E5%83%8F-%E5%86%99%E7%9C%9F/%E7%99%BA%E8%A1%8C%E8%80%85/:id()",
    component: () => import("/Users/xiongzhifan/yinuo/proj_codes/PixelHaha-SSR/pages/images-photos/publisher/[id].vue").then(m => m.default || m)
  },
  {
    name: "images-photos-publisher-id___pt",
    path: "/imagens-fotos/editor/:id()",
    component: () => import("/Users/xiongzhifan/yinuo/proj_codes/PixelHaha-SSR/pages/images-photos/publisher/[id].vue").then(m => m.default || m)
  },
  {
    name: "index___en",
    path: "/",
    component: () => import("/Users/xiongzhifan/yinuo/proj_codes/PixelHaha-SSR/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "index___es",
    path: "/",
    component: () => import("/Users/xiongzhifan/yinuo/proj_codes/PixelHaha-SSR/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "index___fr",
    path: "/",
    component: () => import("/Users/xiongzhifan/yinuo/proj_codes/PixelHaha-SSR/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "index___ja",
    path: "/",
    component: () => import("/Users/xiongzhifan/yinuo/proj_codes/PixelHaha-SSR/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "index___pt",
    path: "/",
    component: () => import("/Users/xiongzhifan/yinuo/proj_codes/PixelHaha-SSR/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "siteMap___en",
    path: "/siteMap",
    component: () => import("/Users/xiongzhifan/yinuo/proj_codes/PixelHaha-SSR/pages/siteMap/index.vue").then(m => m.default || m)
  },
  {
    name: "siteMap___es",
    path: "/siteMap",
    component: () => import("/Users/xiongzhifan/yinuo/proj_codes/PixelHaha-SSR/pages/siteMap/index.vue").then(m => m.default || m)
  },
  {
    name: "siteMap___fr",
    path: "/siteMap",
    component: () => import("/Users/xiongzhifan/yinuo/proj_codes/PixelHaha-SSR/pages/siteMap/index.vue").then(m => m.default || m)
  },
  {
    name: "siteMap___ja",
    path: "/siteMap",
    component: () => import("/Users/xiongzhifan/yinuo/proj_codes/PixelHaha-SSR/pages/siteMap/index.vue").then(m => m.default || m)
  },
  {
    name: "siteMap___pt",
    path: "/siteMap",
    component: () => import("/Users/xiongzhifan/yinuo/proj_codes/PixelHaha-SSR/pages/siteMap/index.vue").then(m => m.default || m)
  }
]